import React from 'react';
import { IconButton } from 'material-ui';
import EditIcon from '../../icons/EditIcon';

const EditRowAction = () => (
  <IconButton aria-label='Edit'>
    <EditIcon />
  </IconButton>
);

export default EditRowAction;



// WEBPACK FOOTER //
// ./src/containers/passengersList/EditRowAction.js